// extracted by mini-css-extract-plugin
module.exports = {"permission_item":"RolesForm_permission_item__1cisM","custom_css_for_button":"RolesForm_custom_css_for_button__3K9pl","custom_button":"RolesForm_custom_button__3oEN4"};